import "./CapacityPacks.module.css";
import EnterpriseHeader from "@/reusable_sections/Header";
import PredictableScaling from "./sections/PredictableScaling";
import ScalableCapacityPacks from "./sections/ScalableCapacityPacks";
import WhatCapacityPacksCover from "./sections/WhatCapacityPacksCover";
import UsageTransparency from "./sections/UsageTransparency";
import UpgradeYourLimit from "./sections/UpgradeYourLimit";
import NetworkFooter from "@/reusable_sections/Footer";
export default function CapacityPacksPage() {
  return <div>
      <EnterpriseHeader />
      <PredictableScaling />
      <ScalableCapacityPacks />
      <WhatCapacityPacksCover />
      <UsageTransparency />
      <UpgradeYourLimit />
      <NetworkFooter />
    </div>;
}